"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("./constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var OrderStatus = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var className = _ref.className,
    href = _ref.href,
    id = _ref.id,
    status = _ref.status,
    onClickId = _ref.onClickId,
    suffix = _ref.suffix;
  var title = _constants.TITLES[status];
  var handleClickId = (0, _react.useCallback)(function () {
    onClickId(id);
  }, [id, href, onClickId]);
  return /*#__PURE__*/_react["default"].createElement(StyledOrderStatus, {
    className: className,
    status: status,
    title: title
  }, id && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\u2116", /*#__PURE__*/_react["default"].createElement(StyledId, {
    onClick: handleClickId
  }, id), ' · '), title, suffix);
});
var StyledOrderStatus = _styledComponents["default"].div.withConfig({
  displayName: "OrderStatus__StyledOrderStatus",
  componentId: "sc-afa72y-0"
})(["font-size:14px;height:23px;line-height:23px;overflow:hidden;margin:0 5px;padding:0 7px;text-align:center;text-overflow:ellipsis;user-select:none;white-space:nowrap;::first-letter{text-transform:uppercase;}", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (_ref2) {
  var status = _ref2.status;
  return status === _constants.ORDER_STATUSES.APPROVED && "\n    background-color: #f1c800;\n    color: #fff;\n  ";
}, function (_ref3) {
  var status = _ref3.status;
  return status === _constants.ORDER_STATUSES.BOOKED && "\n    background-color: #83550a;\n    color: #fff;\n  ";
}, function (_ref4) {
  var status = _ref4.status;
  return status === _constants.ORDER_STATUSES.CANCELED && "\n    background-color: #640000;\n    color: #fff;\n  ";
}, function (_ref5) {
  var status = _ref5.status;
  return status === _constants.ORDER_STATUSES.CONFIRMED && "\n    background-color: #4a90e2;\n    color: #fff;\n  ";
}, function (_ref6) {
  var status = _ref6.status;
  return [_constants.ORDER_STATUSES.DEPOSIT, _constants.ORDER_STATUSES.GOT_BACK, _constants.ORDER_STATUSES.SURVEY_COMPLETED].includes(status) && "\n    background-color: #fff;\n    border: 1px solid #979797;\n    color: #17181a;\n    line-height: 21px;\n  ";
}, function (_ref7) {
  var status = _ref7.status;
  return status === _constants.ORDER_STATUSES.DOCUMENTS_SENT && "\n    background-color: #69027e;\n    color: #fff;\n  ";
}, function (_ref8) {
  var status = _ref8.status;
  return status === _constants.ORDER_STATUSES.FLIGHT_CONFIRMED && "\n    background-color: #30cb90;\n    color: #fff;\n  ";
}, function (_ref9) {
  var status = _ref9.status;
  return status === _constants.ORDER_STATUSES.CREATED && "\n    background-color: #fa6400;\n    color: #fff;\n  ";
}, function (_ref10) {
  var status = _ref10.status;
  return status === _constants.ORDER_STATUSES.NOT_CONFIRMED && "\n    background-color: #bc0000;\n    color: #fff;\n  ";
}, function (_ref11) {
  var status = _ref11.status;
  return status === _constants.ORDER_STATUSES.ON_TRIP && "\n    background-color: #2538df;\n    color: #fff;\n  ";
}, function (_ref12) {
  var status = _ref12.status;
  return status === _constants.ORDER_STATUSES.PAID && "\n    background-color: #00c02c;\n    color: #fff;\n  ";
});
OrderStatus.displayName = 'OrderStatus';
var StyledId = _styledComponents["default"].span.withConfig({
  displayName: "OrderStatus__StyledId",
  componentId: "sc-afa72y-1"
})(["color:inherit;cursor:pointer;text-decoration:none;user-select:initial;:hover{text-decoration:underline;}"]);
var _default = exports["default"] = OrderStatus;